/**
 * Affiliate Service
 *
 * API service for affiliate program endpoints
 */

import apiClient from './api';
import type {
  AffiliateStats,
  AffiliateJoinResponse,
  PayoutRequest,
  PayoutsResponse,
  ConversionsResponse,
  Payout,
} from '@/types/affiliate';

/**
 * API response wrapper
 */
interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export const affiliateService = {
  /**
   * Get affiliate stats for current user
   */
  async getStats(): Promise<AffiliateStats> {
    const response = await apiClient.get<ApiResponse<AffiliateStats>>('/api/affiliates/stats');
    return response.data.data;
  },

  /**
   * Join the affiliate program
   */
  async join(): Promise<AffiliateJoinResponse> {
    const response = await apiClient.post<ApiResponse<AffiliateJoinResponse>>(
      '/api/affiliates/join'
    );
    return response.data.data;
  },

  /**
   * Get conversions list
   */
  async getConversions(params?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<ConversionsResponse> {
    const response = await apiClient.get<ApiResponse<ConversionsResponse>>(
      '/api/affiliates/conversions',
      { params }
    );
    return response.data.data;
  },

  /**
   * Request a payout
   */
  async requestPayout(data: PayoutRequest): Promise<Payout> {
    const response = await apiClient.post<ApiResponse<Payout>>('/api/affiliates/payouts', data);
    return response.data.data;
  },

  /**
   * Get payout history
   */
  async getPayouts(params?: {
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<PayoutsResponse> {
    const response = await apiClient.get<ApiResponse<PayoutsResponse>>(
      '/api/affiliates/payouts',
      { params }
    );
    return response.data.data;
  },
};
